import c from '../common';

export default {
  // Dashboarad
  Title: c.voucher.chn + " & " + c.discount.chn,
  ReDate: "發行日",
  EndDate: "到期日",
  Qty: "數量",
  Released: "已發行",
  Distributed: "已分發",
  EstampReserved: "預留於積分換領",
  RewardReserved: "預留於推廣碼",
  WelcomeReserved: "預留於平台迎新",
  Redeemed: "已換領",
  Sale: "可售賣",
  Minus: "減去",
  Invited: "已參與商店:",
  Data: "數據",
  InventoryControl: "庫存管理",
  AvailQty: "可用庫存",
  SaleReserved: "預留於售賣",
  SelectAll: "全選",
  
  // Message
  Info1: "已派發到消費者手中",
  Info2: "請在簡介描述劵的用途",
  Info3: "需前往 積分頁面 修改",
  Info4: "需前往 推廣碼頁面 修改",
  Info5: "由平台管理人控制, 無法修改",
  Warning1: "請提供封面圖片",
  Warning2: "請選擇券的種類",
  Warning3: "價值不可為0",
  Warning4: "原價不可為0",
  Warning5: "折後價不可為0",
  Warning6: "折後價應小於原價",
  Warning7: "百分比不可為0",
  Warning8: "數量不可為0",
  Warning9: "請填寫名稱",
  Warning10: "請提供到期日",
  Warning11_1: "簡介不能多於 ",
  Warning11_2: " 字",
  Warning12: "請提供最少1項條款",
  Warning13: "請選擇1個推廣活動",
  Warning14: "不可為空",
  Warning15_1: "條款不可超出 ",
  Warning16: "最少一個可兌換商店",
  Success1: "已提交申請, 請等待審批",
  Success2: "成功修改",
  Refresh: "請重新加載",
  Error1: "發生錯誤",
  
  // Status
  Approved: c.Approved.chn,
  WaitApprove: c.WaitApprove.chn,
  Expired: c.Expired.chn,
  Rejected: c.Rejected.chn,
  Cancelled: c.Cancelled.chn,

  // Common
  Voucher: c.voucher.chn,
  Discount: c.discount.chn,
  TakeAway: c.takeaway.chn,
  NA: c.NA.chn,
  Cancel: c.cancel.chn,
  Next: c.next.chn,
  Previous: c.previous.chn,
  Terms: "使用條款",
  Description: "簡介",
  Complete: c.complete.chn,
  To: "至",

  // Step 1
  Create: "發行新劵",
  Photo: "封面圖片",
  Ratio: "長寬比",
  FileSize: "檔案大小",
  Upload: "上傳",

  // Step 2
  Name: "名稱",
  VouType: "劵的種類",
  Value: "價值",
  Amount: "數量",
  Plan: "方案",
  Percentage: "百分比",
  Other: "其他",
  OriPrice: "原價",
  Discounted: "折後價",
  CustomInput: "自訂",
  Template: "從範本選擇",
  AddTerms: "新增使用條款",

  // Step 3
  Event: "推廣活動",
  AvaDate: "電子劵有效期",
  CanRedeem: "可兌換劵",

  // Summary
  Summary: "總結",
  DoubleConfirm: "提交前再次確認資料正確",
  Submit: "提交申請",

  // Result
  ToEstamp: "前往創建積分計劃",
  Skip: "暫時跳過",

  edit: "修改",
  cancel: "取消",
  confirm: "確定",
  addTotalQty: "新增發行數量",
  save: "儲存",
  addQty: "增加數量",
  waitForApprove_alert_title: "審批進行中, 若要更改申請資料, 請先取消申請",
  addTicketQty: "增加劵數量",
  cancelRequest: "取消申請",
  reject_alert_title: "更改資料申請被拒",
  reason: "原因",
  approved_alert_title: "更改已審批",
  draft_alert_title: "更改資料草犒",
  submitRequest: "提交審批",

  custom_expiry_btn: "自訂到期日",
};